import { APIServiceError } from 'frontcore/data/api-service/service-error/errors/service-error'
import { BulkImportErrorResponse } from 'frontcore/presentation/bulk-import/domain/types'


export class APIServiceException<SD = unknown> extends APIServiceError<SD> {}

const isValidInfoResponse = (infoResponse: unknown[]): infoResponse is string[] => {
  return infoResponse.every(infoMessage => typeof infoMessage === 'string')
}

const isValidResponse = (detail: unknown): detail is BulkImportErrorResponse  => {
  if (
    detail === null
    || typeof detail !== 'object'
    || !('error' in detail)
    || !('info' in detail)
  ) {
    return false
  }
  return Array.isArray(detail.info) && isValidInfoResponse(detail.info)
}

export class InvalidFileContentError extends APIServiceException {
  get serviceDetail (): BulkImportErrorResponse {
    if (this.response && isValidResponse(this.response?.data.service_detail)) {
      return this.response.data.service_detail
    }
    return {
      error: {
        additional_errors: [{
          id: 0,
          title: 'Unable to parse errors',
          reason: '',
        }],
      },
      info: [],
    }
  }
}
